import React, { Component } from "react";
import Header from "../header";
import { createGlobalStyle } from "styled-components";

class ContactSupport extends Component {
  state = {
    VendorHeader: true,
  };
  render() {
    const GlobalStyles = createGlobalStyle`body{
            background: #F9F9F9 !important;
          }`;
    return (
      <>
        <GlobalStyles />
        <Header
          showSearchBar={true}
          logosrc={"/"}
          VendorHeader={this.state.VendorHeader}
        />
        <div className="ContactSupportCom">
          <span className="titleCon">تماس با پشتیبانی</span>
          <div className="textCon">
            شما می توانید با استفاده از شماره زیر با پشتیبانی کاچار تماس بگیرید
          </div>
          <div className="Phone">
            <span>041-35578890</span>
            <img src="/public/assets/icons/Vector10.svg" alt="pic" />
          </div>
          <div className="Img">
            <img src="/public/assets/icons/SUPPORT2.svg" alt="pic" />
          </div>
        </div>
      </>
    );
  }
}
export default ContactSupport;
